module.exports = __webpack_public_path__ + "img/p3.6703ef89.svg";